import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'

export class DataDeleteModalStore {
  constructor() {
    makeAutoObservable(this)
  }
}

export const dataDeleteModal = mx.ref<DataDeleteModalStore>()
